// eslint-disable-next-line import/order -- LogRocket must be imported first to properly instrument the app
import LogRocket from 'logrocket';

import './i18n/config';
import { MantineProvider } from '@mantine/core';
import { ThemeProvider } from '@mui/material';
import { Provider as RollbarProvider, ErrorBoundary } from '@rollbar/react';
import ReactDOM from 'react-dom/client';
import '@mantine/core/styles.css';

import { StoreContext, store } from '@stores';
import { globalTheme } from '@styles';
import { rollbar } from '@utils';

import App from './App';
import './styles/custom.css';

// Initialize LogRocket to ensure it works with redirects
// Skip during Playwright tests to avoid consuming production quota
const isTestEnvironment =
  typeof window !== 'undefined' &&
  (window as Window & { isPlaywrightTest?: boolean }).isPlaywrightTest;
if (
  !isTestEnvironment &&
  (import.meta.env.VITE_ROLLBAR_ENVIRONMENT === 'preview' ||
    import.meta.env.VITE_ROLLBAR_ENVIRONMENT === 'dev' ||
    import.meta.env.VITE_ROLLBAR_ENVIRONMENT === 'production')
) {
  if (import.meta.env.VITE_ROLLBAR_ENVIRONMENT === 'production') {
    LogRocket.init('h7br9q/production-nnu8q', {
      dom: {
        inputSanitizer: 'lipsum',
        privateAttributeBlocklist: ['data-logrocket-hidden'],
      },
    });
  } else if (import.meta.env.VITE_ROLLBAR_ENVIRONMENT === 'preview') {
    LogRocket.init('h7br9q/preview-zv3yl', {
      dom: {
        inputSanitizer: 'lipsum',
        privateAttributeBlocklist: ['data-logrocket-hidden'],
      },
    });
  } else {
    LogRocket.init('h7br9q/preview', {
      dom: {
        inputSanitizer: 'lipsum',
        privateAttributeBlocklist: ['data-logrocket-hidden'],
      },
    });
  }
}

// A chunk that fails to load (deploy mid-session, flaky link) reloads the widget once;
// the loader re-sends `initialize` on the next `loaded`, so the session recovers.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  try {
    const key = 'ec:preload-reloaded';
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  } catch {
    // storage unavailable in this frame: still better to reload than to leave a dead chunk
  }
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <RollbarProvider instance={rollbar}>
    <ErrorBoundary>
      <ThemeProvider theme={globalTheme}>
        <MantineProvider forceColorScheme="light">
          <StoreContext.Provider value={store}>
            <App />
          </StoreContext.Provider>
        </MantineProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </RollbarProvider>
);
